import {createContext} from 'react'

export const AgentsWorkbenchContext = createContext(false)
export const AgentsWorkbenchCloseContext = createContext<(() => void) | null>(null)
